import FizConfig from "../FizConfig.js";
import * as Storage from "../lib/Storage.ts";

var 
  i,
  //not starting by than will be ignored, first will be the default one
  acceptableLocales = {
      Family:['en','fr','de','es','pt','it','nl','ja','ru','sv','key']
  }[FizConfig.CONFIG_PARTNER_TYPE],
  
  browserGuessOnlyThose = {
    //telekom_albania:['sq']
  }[FizConfig.CONFIG_PARTNER_TYPE]||acceptableLocales,
  //default
  currentLanguage = browserGuessOnlyThose[0],
  
  //what choices are proposed to user
  selectableLocales = {
    Family:['en','en-us','en-gb','en-ca','en-au','en-za','en-sg','fr-fr','fr-be','fr-ch','nl-be','nl-nl','de-de','de-ch','de-at','es-es','pt-br','pt-pt','it-it','ja-jp','ru-ru']

  }[FizConfig.CONFIG_PARTNER_TYPE],
  
  //long names, no need to translate for now (each name is in its own language)
  names = {
    'nl-be' : 'Dutch (België)',
    'nl-nl' : 'Dutch',
    'de-de' : 'Deutsch',
    'de-at' : 'Deutsch (Österreich)',
    'de-ch' : 'Deutsch (Schweiz)',
    'en' : 'English',
      'en-us' : 'English (US)',
      'en-gb' : 'English (UK)',
      'en-au' : 'English (AU)',
      'en-ca' : 'English (CA)',
      'en-za' : 'English (ZA)',
      'en-sg' : 'English (SG)',
      'es-es' : 'Español',
      'it-it': 'Italiano',
      'fr-fr' : 'Français',
      'fr-be' : 'Français (Belgique)',
      'fr-ch' : 'Français (Suisse)',
      'pt-pt': 'Português',
      'pt-br': 'Português (BR)',
      'ru-ru': 'русский',
      'sq': 'Shqip',
      'ja-jp': '日本'
      
    };

function normalize(newLanguage){
  var items = newLanguage.split(/-|_/g);
  items[0] = items[0].toLowerCase();
  if(items.length>1){
    items[1] = items[1].toUpperCase();
  } 
  return items;
}
//set the language, return true if it changed something
function _set(newLanguage,acceptable){
  if(!newLanguage){
    return false;
  }
  if(!acceptable){
    acceptable = acceptableLocales;
  }
  var items = normalize(newLanguage);
  newLanguage = items.join('-').toLowerCase();
  if(acceptable.indexOf(newLanguage)===-1 && acceptable.indexOf(items[0])===-1){
    return false;
  }
  if(currentLanguage.indexOf(newLanguage)===0){
    //do nothing we have a closer locale (with country code) than new one
    return false;
  }else{
    currentLanguage = newLanguage;
  }
  return true;
}
function updateDom(){
  try{
    document.body.parentNode.lang=currentLanguage;
  }catch(e){
    console.log(e);
  }
}
function get(){
  return currentLanguage;
}
//use browser to set language
_set(navigator.chosenLanguage,browserGuessOnlyThose);
_set(navigator.language,browserGuessOnlyThose);
if(navigator.languages){
  for(i=navigator.languages.length-1;i>=0;i--){
    _set(navigator.languages[i],browserGuessOnlyThose);
  }
}
//use sessionStorage to set language
_set( Storage.sessionGet('lang'));
updateDom();


function set(lang){
  if(!lang) return get();
  try{
    normalize(lang);
  }catch(e){
    console.log('Error with locale '+lang,e);
  }
  if(_set(lang)){
    Storage.sessionSet('lang',get());
    updateDom();
  }
  return get();
}
function locales(){
  var res = [],i,l;
  for(i=0;i<selectableLocales.length;i++){
    l = selectableLocales[i];
    res.push({id:l,text:names[l],selected:l===currentLanguage});
  }
  return res;
}
//https://github.com/thiagodp/country-to-currency/blob/master/index.ts
const currencyPerCountry = {"AD":"EUR","AE":"AED","AF":"AFN","AG":"XCD","AI":"XCD","AL":"ALL","AM":"AMD","AO":"AOA","AR":"ARS","AS":"USD","AT":"EUR","AU":"AUD","AW":"AWG","AX":"EUR","AZ":"AZN","BA":"BAM","BB":"BBD","BD":"BDT","BE":"EUR","BF":"XOF","BG":"BGN","BH":"BHD","BI":"BIF","BJ":"XOF","BL":"EUR","BM":"BMD","BN":"BND","BO":"BOB","BQ":"USD","BR":"BRL","BS":"BSD","BT":"BTN","BV":"NOK","BW":"BWP","BY":"BYN","BZ":"BZD","CA":"CAD","CC":"AUD","CD":"CDF","CF":"XAF","CG":"CDF","CH":"CHF","CI":"XOF","CK":"NZD","CL":"CLP","CM":"XAF","CN":"CNY","CO":"COP","CR":"CRC","CU":"CUC","CV":"CVE","CW":"ANG","CX":"AUD","CY":"EUR","CZ":"CZK","DE":"EUR","DJ":"DJF","DK":"DKK","DM":"DOP","DO":"DOP","DZ":"DZD","EC":"USD","EE":"EUR","EG":"EGP","EH":"MAD","ER":"ERN","ES":"EUR","ET":"ETB","FI":"EUR","FJ":"FJD","FM":"USD","FO":"DKK","FR":"EUR","GA":"XAF","GB":"GBP","GD":"XCD","GE":"GEL","GF":"EUR","GG":"GBP","GH":"GHS","GI":"GIP","GL":"DKK","GM":"GMD","GN":"GNF","GP":"EUR","GQ":"XAF","GR":"EUR","GT":"GTQ","GU":"USD","GW":"XOF","GY":"GYD","HK":"HKD","HN":"HNL","HR":"HRK","HT":"HTG","HU":"HUF","ID":"IDR","IE":"EUR","IL":"ILS","IM":"GBP","IN":"INR","IO":"USD","IQ":"IQD","IR":"IRR","IS":"ISK","IT":"EUR","JE":"GBP","JM":"JMD","JO":"JOD","JP":"JPY","KE":"KES","KG":"KGS","KH":"KHR","KI":"AUD","KM":"KMF","KN":"XCD","KP":"KPW","KR":"KRW","KW":"KWD","KY":"KYD","KZ":"KZT","LB":"LBP","LC":"XCD","LI":"CHF","LK":"LKR","LR":"LRD","LS":"LSL","LT":"EUR","LU":"EUR","LV":"EUR","LY":"LYD","MA":"MAD","MC":"EUR","MD":"MDL","ME":"EUR","MF":"EUR","MG":"MGA","MH":"USD","ML":"XOF","MM":"MMK","MN":"MNT","MO":"MOP","MP":"USD","MQ":"EUR","MR":"MRU","MS":"XCD","MT":"EUR","MU":"MUR","MV":"MVR","MW":"MWK","MX":"MXN","MY":"MYR","MZ":"MZN","NA":"NAD","NC":"XPF","NE":"NGN","NF":"AUD","NG":"NGN","NI":"NIO","NL":"EUR","NO":"NOK","NP":"NPR","NR":"AUD","NU":"NZD","NZ":"NZD","OM":"OMR","PA":"PAB","PE":"PEN","PF":"XPF","PG":"PGK","PH":"PHP","PK":"PKR","PL":"PLN","PM":"EUR","PN":"NZD","PR":"USD","PT":"EUR","PW":"USD","PY":"PYG","QA":"QAR","RE":"EUR","RO":"RON","RS":"RSD","RU":"RUB","RW":"RWF","SA":"SAR","SB":"SBD","SC":"SCR","SD":"SDG","SE":"SEK","SG":"SGD","SH":"SHP","SI":"EUR","SJ":"NOK","SK":"EUR","SL":"SLL","SM":"EUR","SN":"XOF","SO":"SOS","SR":"SRD","SS":"SSP","ST":"STN","SV":"SVC","SX":"ANG","SY":"SYP","SZ":"SZL","TC":"USD","TD":"XAF","TF":"EUR","TG":"XOF","TH":"THB","TJ":"TJS","TK":"NZD","TL":"USD","TM":"TMT","TN":"TND","TO":"TOP","TR":"TRY","TT":"TTD","TV":"AUD","TW":"TWD","TZ":"TZS","UA":"UAH","UG":"UGX","UM":"USD","US":"USD","UY":"UYU","UZ":"UZS","VA":"EUR","VC":"XCD","VE":"VES","VG":"USD","VI":"USD","VN":"VND","VU":"VUV","WF":"XPF","WS":"USD","YE":"YER","YT":"EUR","ZA":"ZAR","ZM":"ZMW","ZW":"ZWL","HM":"AUD","FK":"FKP","GS":"GEL","LA":"LAK","MK":"MKD","AQ":"USD","PS":"ILS"};
function guessCurrency(){
  for(let language of [get(),... navigator.languages]){
    let 
      country = language.split(/-|_/)[1]?.toUpperCase(),
      currency = currencyPerCountry[country];
    if(currency){
      return currency;
    }
    
  }
  return 'EUR';
}

export {get,set,locales,guessCurrency}